import frame from './ListFrame.vue'
const ListFrame = {
	install: function(Vue) {
		Vue.component('ListFrame', frame)
	}
}
export default ListFrame
